<template>
    <div>
        数据源管理
    </div>
</template>
<script>
export default {
    name: 'AourceManagement',
    data() {
        return {
            title: '数据源管理'
        }
    }
}
</script>
<style scoped>

</style>
